import BaseAPI from './base'

class StudentPackageDetailAPI extends BaseAPI {}

export default new StudentPackageDetailAPI('v1/student-package-details', 'StudentPackage')
